import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetch_vendor_training_packages,
  accept_training_package,
  reject_training_package,
  preview_training_package,
  create_training_package,
  pay_training_package,
  verify_training_package_payment,
  fetch_my_training_packages,
  cancel_training_package,
} from './api';
import type { TrainingPackageSchedule, CreateTrainingPackageRequest, VerifyPackagePaymentRequest } from './types';

export function use_vendor_training_packages() {
  return useQuery({
    queryKey: ['vendor-training-packages'],
    queryFn: fetch_vendor_training_packages,
  });
}

export function use_my_training_packages() {
  return useQuery({
    queryKey: ['my-training-packages'],
    queryFn: fetch_my_training_packages,
  });
}

export function use_accept_training_package() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => accept_training_package(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['vendor-training-packages'] });
      qc.invalidateQueries({ queryKey: ['vendor-bookings'] });
    },
  });
}

export function use_reject_training_package() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason?: string }) => reject_training_package(id, reason),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['vendor-training-packages'] });
      qc.invalidateQueries({ queryKey: ['vendor-bookings'] });
    },
  });
}

export function use_preview_training_package() {
  return useMutation({ mutationFn: (input: TrainingPackageSchedule) => preview_training_package(input) });
}

export function use_create_training_package() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateTrainingPackageRequest) => create_training_package(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['my-training-packages'] }),
  });
}

export function use_pay_training_package() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => pay_training_package(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['my-training-packages'] });
      qc.invalidateQueries({ queryKey: ['my-bookings'] });
    },
  });
}

export function use_verify_training_package_payment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: VerifyPackagePaymentRequest }) => verify_training_package_payment(id, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['my-training-packages'] });
      qc.invalidateQueries({ queryKey: ['my-bookings'] });
    },
  });
}

export function use_cancel_training_package() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason?: string }) => cancel_training_package(id, reason),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['my-training-packages'] });
      qc.invalidateQueries({ queryKey: ['my-bookings'] });
    },
  });
}
